import BaseEntity from './BaseEntity'
import createVideo from './Video'

const Props = {
  description: undefined,
  video: undefined,
}

class Step extends BaseEntity {
  constructor(params) {
    super(params)
    this.video = createVideo(params.video || {})
  }
}

export default function createSteps(params) {
  let steps = []
  params.forEach((step) => {
    const attr = Object.assign({}, Props, step)
    steps.push(new Step(attr))
  })
  return Object.freeze(steps)
}
